"use client";
import { Text as e } from "../Text/Text.mjs";
import { forwardRef as t, isValidElement as n } from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-alert-dialog";
//#region src/components/atoms/AlertDialog/AlertDialog.tsx
var o = (e) => /* @__PURE__ */ r(a.Root, {
	"data-slot": "alert-dialog",
	...e
}), s = t((e, t) => /* @__PURE__ */ r(a.Trigger, {
	"data-slot": "alert-dialog-trigger",
	...e,
	ref: t
}));
s.displayName = "AlertDialogTrigger";
var c = (e) => /* @__PURE__ */ r(a.Portal, {
	"data-slot": "alert-dialog-portal",
	...e
}), l = t((e, t) => /* @__PURE__ */ r(a.Overlay, {
	"data-slot": "alert-dialog-overlay",
	...e,
	ref: t
}));
l.displayName = "AlertDialogOverlay";
var u = t((e, t) => /* @__PURE__ */ i(c, { children: [/* @__PURE__ */ r(l, {}), /* @__PURE__ */ r(a.Content, {
	"data-slot": "alert-dialog-content",
	...e,
	ref: t
})] }));
u.displayName = "AlertDialogContent";
var d = t(({ children: t, fontSize: i = "lg", fontWeight: o = "semibold", fontFamily: s = "inter", ...c }, l) => /* @__PURE__ */ r(a.Title, {
	"data-slot": "alert-dialog-title",
	...c,
	ref: l,
	children: /* @__PURE__ */ r(e, {
		asChild: !0,
		fontSize: i,
		fontWeight: o,
		fontFamily: s,
		children: n(t) ? t : /* @__PURE__ */ r("span", { children: t })
	})
}));
d.displayName = "AlertDialogTitle";
var f = t(({ children: t, fontSize: i = "sm", fontWeight: o = "regular", fontFamily: s = "inter", ...c }, l) => /* @__PURE__ */ r(a.Description, {
	"data-slot": "alert-dialog-description",
	...c,
	ref: l,
	children: /* @__PURE__ */ r(e, {
		asChild: !0,
		fontSize: i,
		fontWeight: o,
		fontFamily: s,
		children: n(t) ? t : /* @__PURE__ */ r("span", { children: t })
	})
}));
f.displayName = "AlertDialogDescription";
var p = t((e, t) => /* @__PURE__ */ r(a.Action, {
	"data-slot": "alert-dialog-action",
	...e,
	ref: t
}));
p.displayName = "AlertDialogAction";
var m = t((e, t) => /* @__PURE__ */ r(a.Cancel, {
	"data-slot": "alert-dialog-cancel",
	...e,
	ref: t
}));
m.displayName = "AlertDialogCancel";
//#endregion
export { p as AlertDialogAction, m as AlertDialogCancel, u as AlertDialogContent, f as AlertDialogDescription, l as AlertDialogOverlay, c as AlertDialogPortal, o as AlertDialogRoot, d as AlertDialogTitle, s as AlertDialogTrigger };
